import { AppError } from '../errorHandling/app-error';

export class DevExtremeDataError extends AppError {
    constructor(area: string, errorCode: string, userMessage: string, stack?: string | undefined, innerError?: Error) {
        super(area, errorCode, userMessage, stack, innerError);
    }

    public isDevExtremeDataError() {
        return true;
    }
}

export class DevExtremeDataErrorFactory {
    public static fromError(exception: any, source: string): DevExtremeDataError {
        if (exception instanceof DevExtremeDataError) {
            return exception;
        }
        else if (exception instanceof AppError) {
            return new DevExtremeDataError(source, exception.errorCode, exception.message, exception.stack, exception);
        }
        else {
            return new DevExtremeDataError(source, "GenericError", exception.message, exception.stack, exception);
        }
    }
}